import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'stable',
      d: 'M-4,-3h1.5v0.5h-1.5zM-4,-2.5h1v2h-1zM-1.5,-2.5h0.5v2h-0.5zM2.5,-2h0.5v0.5h-0.5zM1,-1.5h0.5v1.5h-0.5zM-2.5,-1h0.5v0.5h-0.5zM-2,-0.5h1.5v0.5h-1.5zM0.5,0h1v0.5h-1z',
    },
    {
      paint: [
        ['shadow', 0.24],
        ['stable', 0.76],
      ],
      d: 'M-2,-2.5h0.5v0.5h-0.5zM-1,-2h0.5v1.5h-0.5zM0.5,-2h0.5v1.5h-0.5zM3,-2h1v0.5h-1zM1.5,-1.5h0.5v1h-0.5zM3.5,-1.5h0.5v1h-0.5zM-2,-1h0.5v0.5h-0.5zM-3,-0.5h1v0.5h-1zM0,-0.5h1v0.5h-1zM1.5,-0.5h2v0.5h-2zM-0.5,0h1v0.5h-1zM1.5,0h1v0.5h-1z',
    },
    {
      paint: 'roofB',
      d: 'M-2.5,-5.5h0.5v0.5h-0.5zM-3,-5h1.5v0.5h-1.5zM-3.5,-4.5h2.5v0.5h-2.5zM-4,-4h3.5v0.5h-3.5zM-4.5,-3.5h4.5v0.5h-4.5zM-2.5,-3h3v0.5h-3zM0,-2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['roofB', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-2,-5.5h1.5v0.5h-1.5zM-1.5,-5h3v0.5h-3zM-1,-4.5h4.5v0.5h-4.5zM-0.5,-4h4.5v0.5h-4.5zM0,-3.5h4v0.5h-4zM0.5,-3h4v0.5h-4zM-1,-2.5h1v0.5h-1zM1,-2.5h3v0.5h-3zM1,-2h1.5v0.5h-1.5z',
    },
    { paint: 'shadow', d: 'M-3,-2.5h1v0.5h-1zM-3,-2h1.5v1h-1.5zM-0.5,-2h1v1.5h-1z' },
    {
      paint: [
        ['sail', 0.22],
        ['stable', 0.78],
      ],
      d: 'M-3,-1h0.5v0.5h-0.5zM-0.5,-0.5h0.5v0.5h-0.5z',
    },
    { paint: 'fence', d: 'M-3.5,-0.5h0.5v0.5h-0.5zM-1,0h0.5v0.5h-0.5z' },
    { paint: 'haybale', d: 'M2,-1.5h1.5v1h-1.5z' },
  ],
  pixels: 162,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
